import { render, staticRenderFns } from "./RevenueLoadedItemsTable.vue?vue&type=template&id=53004022"
import script from "./RevenueLoadedItemsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueLoadedItemsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports